export default __webpack_public_path__ + "static/media/Stanford.510ef575.png";